import FlowConfigBase from '#client/config/FlowConfigBase';
import * as ROUTES from '#client/constants/routes';

import PAGES, { PAGE_KEYS } from '../flowPageConfig';

const POST_ORDER_REDIRECT = `${ROUTES.SHOP_SMART_LLC}/${PAGES.CONCLUSION_SMART_LLC.path}`;

export default FlowConfigBase.createEntry({
  id: 'smart-llc',
  pageKeys: [
    PAGE_KEYS.BUSINESS_WEBSITE,
    PAGE_KEYS.CHECKOUT_SMART_LLC,
    PAGE_KEYS.CONCLUSION_SMART_LLC
  ],
  pageConfigs: {
    [PAGES.BUSINESS_WEBSITE.pageComponent]: {
      pageComponentProps: {
        servicesCoupons: {
          registered_agent_service: 'registered_agent_service_deferred_100'
        }
      }
    }
  },
  clickStreamProps: {
    dynamicProperties: {
      ai_project_name: 'one_click_formation'
    }
  },
  autoResume: false,
  entityType: 'llc',
  hasFormation: true,
  isPrimary: true,
  postOrderAutoLogin: true,
  postOrderRedirect: POST_ORDER_REDIRECT,
  priceListUuids: {
    development: '3c9da872-c96d-4e28-be04-4dd8cf8e1a2e',
    production: '19a705a4-3241-4f65-aef1-74a95f6f49b8'
  }
});
